module.exports = __webpack_public_path__ + "img/pr-7.135d351c.png";